"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PosBodyToJSON = exports.PosBodyFromJSONTyped = exports.PosBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function PosBodyFromJSON(json) {
    return PosBodyFromJSONTyped(json, false);
}
exports.PosBodyFromJSON = PosBodyFromJSON;
function PosBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'itsaCheckmateLabel': !(0, runtime_1.exists)(json, 'itsaCheckmateLabel') ? undefined : json['itsaCheckmateLabel'],
    };
}
exports.PosBodyFromJSONTyped = PosBodyFromJSONTyped;
function PosBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'description': value.description,
        'itsaCheckmateLabel': value.itsaCheckmateLabel,
    };
}
exports.PosBodyToJSON = PosBodyToJSON;
